import React from 'react';
import styles from './Products.module.css';
import { PRICE, NAME, ASCENDING, ALL_PRODUCTS, SOLID_FUEL_BOILERS, PELLET_BOILERS, INDUSTRIAL_BOILERS, BOILERS, BURNERS, ACCESORIES, PROMOTIONS, initialList, allProducts } from "./../API/ProductsAPI";
import SearchBar from './SearchBar/SearchBar';
import Navigation from './../Navigation/Navigation';
import { NavLink } from "react-router-dom";
import useTabTitle from '../Hooks/useTabTitle';
import RecentProducts from './../RecentProducts/RecentProducts';

const Products = (props) => {
    const setTabTitle = useTabTitle('Catalog de producție')

    const filterProductsByType = (type, name) => {
        setTabTitle(name)
        props.setActiveCategory(type)

        switch (type) {
            case ALL_PRODUCTS:
                props.setProducts(initialList.map((id) => allProducts.find((product) => product.id === id)));
                break;
            case PROMOTIONS:
                props.setProducts(allProducts.filter(el => el.promotion === true));
                break;
            default:
                props.setProducts(allProducts.filter(el => el.type.includes(type)))
        }
    }

    const sortBy = (type, order) => {
        switch (type) {
            case PRICE:
                if (order === ASCENDING) {
                    props.setProducts([...props.products].sort((a, b) => a.price - b.price))
                }
                else
                    props.setProducts([...props.products].sort((a, b) => b.price - a.price))
                break
            case NAME:
                if (order === ASCENDING)
                    props.setProducts([...props.products].sort((a, b) => a.name.localeCompare(b.name)))
                else
                    props.setProducts([...props.products].sort((a, b) => b.name.localeCompare(a.name)))
                break
            default:

        }
    }

    return (
        <>
            <Navigation productsRef={props.productsRef} setProducts={props.setProducts} setActiveCategory={props.setActiveCategory} />
            <SearchBar productsRef={props.productsRef} sortBy={sortBy} />
            <div className={styles.container}>
                <aside className={styles.sidebar}>
                    <ul>
                        <li className={props.activeCategory === ALL_PRODUCTS ? styles.active : ''}
                            onClick={() => filterProductsByType(ALL_PRODUCTS, 'Catalog de producție')}>Toate produsele</li>
                        <li className={props.activeCategory === PELLET_BOILERS ? styles.active : ''}
                            onClick={() => filterProductsByType(PELLET_BOILERS, 'Centrale pe peleți')}>Centrale pe peleți</li>
                        <li className={props.activeCategory === SOLID_FUEL_BOILERS ? styles.active : ''}
                            onClick={() => filterProductsByType(SOLID_FUEL_BOILERS, 'Cazane pe combustibil solid')}>Cazane pe combustibil solid</li>
                        <li className={props.activeCategory === INDUSTRIAL_BOILERS ? styles.active : ''}
                            onClick={() => filterProductsByType(INDUSTRIAL_BOILERS, 'Centrale și cazane industriale')}>Centrale și cazane industriale</li>
                        <li className={props.activeCategory === BOILERS ? styles.active : ''}
                            onClick={() => filterProductsByType(BOILERS, 'Boilere, acumulatoare și puffere')}>Boilere, acumulatoare și puffere</li>
                        <li className={props.activeCategory === BURNERS ? styles.active : ''}
                            onClick={() => filterProductsByType(BURNERS, 'Arzătoare pe peleți')}>Arzătoare pe peleți</li>
                        <li className={props.activeCategory === ACCESORIES ? styles.active : ''}
                            onClick={() => filterProductsByType(ACCESORIES, 'Accesorii')}>Accesorii</li>
                        <li className={props.activeCategory === PROMOTIONS ? styles.active : ''}
                            onClick={() => filterProductsByType(PROMOTIONS, 'Promoții')}>Promoții</li>
                    </ul>
                </aside>
                <div className={styles.containerProducts}>
                    <div className={styles.grid}>
                        {props.products.map((product) => (
                            <div key={product.id} className={styles.productCard}>
                                <NavLink to={`/product/${product.id}`} className={styles.link}>
                                    <img src={product.image} alt={product.name} className={styles.image} />
                                    <h3 className={styles.productName}>{product.name}</h3>
                                    <p className={styles.productPrice}>{product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} RON</p>
                                </NavLink>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <RecentProducts recentViewedProducts={props.recentViewedProducts} setCart={props.setCart} />
        </>
    );
};

export default Products;
